module.exports = __webpack_public_path__ + "img/sneek-3.55886e36.jpg";